import { createFeatureSelector, createSelector, Selector } from '@ngrx/store';

import * as fromReducer from './mdm-devices.reducer';
import * as fromState from './mdm-devices.state';
import { Device } from '@rocksoft/mdm-sdk-v2';
import { Dictionary } from '@ngrx/entity';
import { DevicesRouterStoreSelectors } from '../router';

export const selectDevicesState: Selector<object, fromState.DeviceState> = createFeatureSelector<fromState.DeviceState>(
  fromReducer.mdmDevicesFeatureKey
);

export const selectDeviceIds: Selector<object, string[] | number[]> = createSelector(
  selectDevicesState,
  fromReducer.selectDeviceIds
);

export const selectDeviceEntities: Selector<object, Dictionary<Device>> = createSelector(
  selectDevicesState,
  fromReducer.selectDevicesEntities
);

export const selectAllDevices: Selector<object, Device[]> = createSelector(
  selectDevicesState,
  fromReducer.selectAllDevices
);

export const selectAllDevicesLoaded: Selector<object, boolean> = createSelector(
  selectAllDevices,
  (settings) => settings && settings.length > 0
);

export const selectCurrentDevice = createSelector(
  selectAllDevices,
  DevicesRouterStoreSelectors.selectUdid,
  (devices, udid) => devices.find((x) => x.identifier === udid)
);
